import { apiGet, apiPatch } from "./http";
import type { OrgFeatures } from "../../api/org-features";

export type { OrgFeatures };

export function getOrgFeatures(signal?: AbortSignal): Promise<OrgFeatures> {
  return apiGet("/api/orgs/features", signal);
}

/** Platform admin only: applies to the active organization. */
export function setOrgFeatures(changes: Partial<OrgFeatures>): Promise<OrgFeatures> {
  return apiPatch("/api/orgs/features", changes);
}
